<template>
    <div class="info-wrap">
        <!-- 退出直播 start -->
        <back class="back" @quitGroup="quitGroup"></back>
        <img src="../../../../assets/image/live/refresh.png" class="refresh" @click="refresh"/>
        <!-- 退出直播 end -->
        <!-- 主播信息 -->
        <div class="an-infos" v-if="ownerInfo&&ownerInfo.avatar">
            <img :src="ownerInfo.avatar" class="avtar" />
            <div class="info">
                <div class="an-name">{{ownerInfo.nick}}</div>
                <div class="an-fans">{{ownerInfo.fans}}粉丝</div>
            </div>
            <div class="attention" @click="attentionBtn">{{ifLike?'已关注':'关注'}}</div>
        </div>
        <!-- 直播间信息 -->
        <div class="room-id-info" v-if="groupInfo&&groupInfo.groupID">
            直播间ID：{{groupInfo.groupID}}
        </div>
        <div class="online" v-if="groupInfo.memberNum">{{groupInfo.memberNum}}人在看</div>
        <!-- 区域信息 -->
        <!-- 观看人数信息 -->
        <!-- 优惠券 -->
        <img v-if="showcoupon" src="../../../../assets/image/live/red-pack.png" class="red-pack" @click="coupon"/>
    </div>
</template>

<script>
import back from './back'
export default {
  props: {
    userInfo: {},
    groupInfo: {},
    ownerInfo: {},
    showcoupon: {},
    ifLike: {}
  },
  data () {
    return {
    }
  },
  methods: {
    coupon () {
      this.$emit('coupon')
    },
    quitGroup () {
      this.$emit('quitGroup')
    },
    attentionBtn () {
      this.$emit('attention')
    },
    refresh () {
      location.reload()
    }
  },
  components: {
    back
  },
  computed: {},
  created () {
    // this.profileCustomField = this.userInfo.profileCustomField
  }
}
</script>
<style type="scss" scoped>
    .back{
        position: absolute;
        right: 0.50625rem;
        top: 1.940625rem;
    }
    .refresh{
        width: 1.6rem;
        height: 1.6rem;
        position: absolute;
        right: 2.5rem;
        top: 1.940625rem;
    }
    .avtar {
        width: 1.51875rem;
        height: 1.51875rem;
        display: inline-block;
        vertical-align: middle;
        border-radius: 0.759375rem;
        overflow: hidden;
    }
    .info {
        display: inline-block;
        color: #000;
        vertical-align: middle;
        padding-left: 0.2109375rem;
        max-width: 2.953125rem;
    }
    .attention {
        width: 1.9828125rem;
        height: 1.265625rem;
        background: rgba(255,255,255,.5);
        border-radius: 0.6328125rem;
        border-radius: 0.6328125rem;
        font-family: PingFangSC-Medium;
        font-size: 0.6rem;
        color: #FFF;
        letter-spacing: 0;
        text-align: center;
        display: inline-block;
        padding: 0;
        line-height: 1.265625rem;
        vertical-align: middle;
        position: absolute;
        top: 0.2109375rem;
        right: 0.2109375rem;
    }
    .an-infos {
        background: rgba(0, 0, 0, 0.25);
        border-radius: 0.84375rem;
        width: 6.7921875rem;
        height: 1.51875rem;
        padding: 0.084375rem;
        position: relative
    }
    .an-name {
        font-family: PingFangSC-Medium;
        font-size: 0.6rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: left;
        line-height: 0.6rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap
    }
    .an-fans {
        font-family: PingFangSC-Regular;
        font-size: 0.5rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: left;
        line-height: 0.5rem;
        margin-top: 0.2109375rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap
    }
    .info-wrap {
        padding: 1.940625rem 0.4640625rem;
    }
    .room-id-info {
        width: 6.328125rem;
        height: 0.50625rem;
        background: rgba(0, 0, 0, 0.25);
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        font-family: PingFangSC-Regular;
        font-size: 0.5rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.50625rem;
        padding: 0.16875rem;
        margin-top: 0.2109375rem;
    }
    .online {
        width: 3.31171875rem;
        height: 0.90703125rem;
        background: rgba(0, 0, 0, 0.25);
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        font-family: PingFangSC-Regular;
        font-size: 0.5rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.90703125rem;
        position: absolute;
        right: 0.50625rem;
        top: 3.8390625rem;
    }
    .red-pack {
        /* background-image: linear-gradient(180deg, #FF9C9C 8%, #F37474 100%); */
        border-radius: 0.084375rem;
        height: 2.29921875rem;
        width: 1.75078125rem;
        position: absolute;
        right: 0.50625rem;
        top: 5.6953125rem;
        z-index: 1000;
    }
</style>
